import { render, staticRenderFns } from "./BirdDogDashboard.vue?vue&type=template&id=554ce66a&"
import script from "./BirdDogDashboard.vue?vue&type=script&lang=js&"
export * from "./BirdDogDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports